import { Modal } from "react-bootstrap"
import moment from "moment"

import useCallApi from "../../../../../hooks/useCallApi"
import Loading from "../../../../../templates/UI/Loading/Loading"

const TrackingPlatformsHistoryModal = ({ isOpen, onClose, platform }) => {

    const { dataLoaded, data } = useCallApi(`advertisers/platforms/${platform.id}/history`, 'GET', {}, [platform.id])

    return (
        <Modal show={isOpen} onHide={onClose} size="xl">
            <Modal.Header closeButton>
                <Modal.Title>Tracking Platform History For : <strong>{platform.name}</strong></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <table className="table table-striped table-bordered table-hover m-0">
                    <thead>
                        <th>Date</th>
                        <th>Supports multiple postback</th>
                        <th>API Tracking</th>
                        <th>Allows SafeSearch</th>
                        <th>SafeSearch Certified</th>
                        <th>SafeSearch Key</th>
                        <th>SafeSearch Value</th>
                        <th>SafeSearch URL Param</th>
                        <th>Updated By</th>
                    </thead>
                    <tbody>
                        {dataLoaded ?
                            <>
                                {data.report.length === 0 ?
                                    <tr>
                                        <td colSpan={9} className="text-center">No Platform History Available.</td>
                                    </tr>
                                    :
                                    data.report.map((item, index) => (
                                        <tr key={index}>
                                            <td>{moment(item.db_date).utc().format('YYYY-MM-DD HH:mm:ss')}</td>
                                            <td>{item.supports_multiple_postback === 'Y' ? 'Yes' : 'No'}</td>
                                            <td>{item.api_tracking === 'Y' ? 'Yes' : 'No'}</td>
                                            <td>{item.allows_safesearch === 'Y' ? 'Yes' : 'No'}</td>
                                            <td>{item.safesearch_certified === 'Y' ? 'Yes' : 'No'}</td>
                                            <td>{item.safesearch_enable_param}</td>
                                            <td>{item.safesearch_enable_value}</td>
                                            <td>{item.safesearch_url_param}</td>
                                            <td>{item.full_name}</td>
                                        </tr>
                                    ))}
                            </>
                            :
                            <tr>
                                <td colSpan={9}>
                                    <Loading />
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </Modal.Body>
        </Modal>
    )
}

export default TrackingPlatformsHistoryModal